import { CHECKBOX, RADIO } from '../constants';

const SIZE_INFO = Object.freeze({
  '32': { label: 'Up to 32"', value: '', preQuestion: { qid: 1419, answers:  { id: 4100 } }},
  '33-60': { label: '33" - 60"', value: 70, preQuestion: { qid: 1419, answers:  { id: 4101 } }},
  '61': { label: '61" or larger', value: 100, preQuestion: { qid: 1419, answers:  { id: 4102 } }}
});

/**
 *  OUR DECISION is fairly base. We seperated it out in answers and the decisionTree.
 *  Our decision tree will merge answer behaviors w/ the answer proper. Any overrides will happen in
 *  the decision tree.
 *  1. Add any 'new' answers
 *     i. if same answer id's have different values, that is ok, the tree will handle the override in the groups.
 *  2. Apply that answer to a question. What group is it part of? No seperate groups will default to group A.
 *
 */
export const answers = {
    insignia: { id: 48, label: 'Insignia' },
    samsung: { id: 16, label: 'Samsung' },
    lg: { id: 46, label: 'LG' },
    tcl: { id: 44, label: 'TCL' },
    hisense: { id: 50, label: 'Hisense' },
    vizio: { id: 45, label: 'Vizio' },
    sceptre: { id: 49, label: 'Sceptre' },
    toshiba: { id: 47, label: 'Toshiba' },
    brandOther: { id: 'brandOther', label: 'Other' },
    samsung32: { id: 136, ...SIZE_INFO['32'] },
    samsung60: { id: 137, ...SIZE_INFO['33-60'] },
    samsungLarge: { id: 138, ...SIZE_INFO['61'] },
    tcl32: { id: 140, ...SIZE_INFO['32'] },
    tcl60: { id: 141, ...SIZE_INFO['33-60'] },
    tclLarge: { id: 142, ...SIZE_INFO['61'] },
    vizio32: { id: 143, ...SIZE_INFO['32'] },
    vizio60: { id: 144, ...SIZE_INFO['33-60'] },
    vizioLarge: { id: 145, ...SIZE_INFO['61'] },
    lg32: { id: 147, ...SIZE_INFO['32'] },
    lg60: { id: 148, ...SIZE_INFO['33-60'] },
    lgLarge: { id: 149, ...SIZE_INFO['61'] },
    toshiba32: { id: 151, ...SIZE_INFO['32'] },
    toshiba60: { id: 152, ...SIZE_INFO['33-60'] },
    toshibaLarge: { id: 153, ...SIZE_INFO['61'] },
    insignia32: { id: 155, ...SIZE_INFO['32'] },
    insignia60: { id: 156, ...SIZE_INFO['33-60'] },
    insigniaLarge: { id: 157, ...SIZE_INFO['61'] },
    sceptre32: { id: 158, ...SIZE_INFO['32'] },
    sceptre60: { id: 159, ...SIZE_INFO['33-60'] },
    sceptreLarge: { id: 160, ...SIZE_INFO['61'] },
    hisense32: { id: 162, ...SIZE_INFO['32'] },
    hisense60: { id: 163, ...SIZE_INFO['33-60'] },
    hisenseLarge: { id: 164, ...SIZE_INFO['61'] },
    '32': { id: '32', ...SIZE_INFO['32'] },
    '33-60': { id: '33-60', ...SIZE_INFO['33-60'] },
    '61': { id: '61', ...SIZE_INFO['61'] },
    3792: { id: 3792, label: 'I have my own mount', },
    3793: { id: 3793, label: 'Tilting mount', value: 59},
    3796: { id: 3796, label: 'Full motion mount', value: 79},
    3794: { id: 3794, label: 'Tilting mount', value: 79},
    3797: { id: 3797, label: 'Full motion mount', value: 99},
    3795: { id: 3795, label: 'Tilting mount', value: 99},
    3798: { id: 3798, label: 'Full motion mount', value: 149},
    3799: { id: 3799, label: 'Yes', value: ''},
    3800: { id: 3800, label: 'No', value: ''},
    3787: { id: 3787, label: 'Drywall - Wood Studs', value: ''},
    3789: { id: 3789, label: 'Drywall - Metal Studs',  value: 69},
    3788: { id: 3788, label: 'Brick', value: 69},
    3790: { id: 3790, label: 'Above a fireplace', hint: 'Wall above a fireplace must be drywall/sheetrock', value: 69},
    3791: { id: 3791, label: 'Other', value: '' },
    'internal': {
      label: 'In-wall cord concealment',
      children: [
        { id: 3828, label: 'I have the parts (+$69)', value: 69 },
        { id: 5269, label: 'I need the parts (+$149)', value: 149 } ,
    ]},
    'external': {
      label: 'External cord masking',
      children: [
        { id: 10180, label: 'I have the parts (+$29)', value: 29 },
        { id: 3829,   label: 'I need the parts (+$39)', value: 39 },
    ]},
    3826: { id: 3826, label: 'Mount a soundbar (+$59)', value: 59 },
    3827: { id: 3827, label: 'Install basic wall shelves (+$49)', value: 49 },
    3825: { id: 3825, label: 'Dismount existing TV (+$79)', value: 79 },
}


/**
 *  Decision Tree
 *
 *  Answers will live under 'children', slotted into a group. Default is A.
 *  Spread out the needed answers, and add:
 *  @param answerType - RADIO, CHECKBOX
 *  @param path - this is the question id the answer links to
 *  @param group - if there is a specific group within a question to link to.
 */
export const decisionTree = () => ({
  seedQuestion: 'product',
  maxFlow: 6,
  'brand' : {
    id: 'brand',
    label: 'What brand is your TV?',
    answerType: RADIO,
    idsToStopAdvancement: ['brandOther'],
    children: {
      A: [
        { ...answers.insignia, path: 'product', group: 'A' },
        { ...answers.samsung,  path: 'product', group: 'B' },
        { ...answers.lg,       path: 'product', group: 'C' },
        { ...answers.tcl,      path: 'product', group: 'D' },
        { ...answers.hisense,  path: 'product', group: 'E' },
        { ...answers.vizio,    path: 'product', group: 'F' },
        { ...answers.sceptre,  path: 'product', group: 'G' },
        { ...answers.toshiba,  path: 'product', group: 'H' },
        { ...answers.brandOther,    path: 'product', group: 'I', showInput: true },
      ]
    }
  },
  'product': {
    id: 'product',
    label: 'What size is your TV?',
    answerType: RADIO,
    children: {
      A: [
        { ...answers.insignia32,    path: '1288', group: 'A' },
        { ...answers.insignia60,    path: '1288', group: 'B' },
        { ...answers.insigniaLarge, path: '1288', group: 'C' },
      ],
      B: [
        { ...answers.samsung32,     path: '1288', group: 'A' },
        { ...answers.samsung60,     path: '1288', group: 'B' },
        { ...answers.samsungLarge,  path: '1288', group: 'C' },
      ],
      C: [
        { ...answers.lg32,          path: '1288', group: 'A' },
        { ...answers.lg60,          path: '1288', group: 'B' },
        { ...answers.lgLarge,       path: '1288', group: 'C' },
      ],
      D: [
        { ...answers.tcl32,         path: '1288', group: 'A' },
        { ...answers.tcl60,         path: '1288', group: 'B' },
        { ...answers.tclLarge,      path: '1288', group: 'C' },
      ],
      E: [
        { ...answers.hisense32,     path: '1288', group: 'A' },
        { ...answers.hisense60,     path: '1288', group: 'B' },
        { ...answers.hisenseLarge,  path: '1288', group: 'C' },
      ],
      F: [
        { ...answers.vizio32,       path: '1288', group: 'A' },
        { ...answers.vizio60,       path: '1288', group: 'B' },
        { ...answers.vizioLarge,    path: '1288', group: 'C' },
      ],
      G: [
        { ...answers.sceptre32,     path: '1288', group: 'A' },
        { ...answers.sceptre60,     path: '1288', group: 'B' },
        { ...answers.sceptreLarge,  path: '1288', group: 'C' },
      ],
      H: [
        { ...answers.toshiba32,     path: '1288', group: 'A' },
        { ...answers.toshiba60,     path: '1288', group: 'B' },
        { ...answers.toshibaLarge,  path: '1288', group: 'C' },
      ],
      I: [
        { ...answers[32],           path: '1288', group: 'A' },
        { ...answers['33-60'],      path: '1288', group: 'B' },
        { ...answers[61],           path: '1288', group: 'C' },
      ]
    }
  },
  1288: { // What type of mount
    id: 1288,
    label: 'What type of mount do you need provided?',
    answerType: RADIO,
    children: {
      A: [
        { ...answers[3792], path: '1287', flowAdjustment: -1},
        { ...answers[3793], path: '1287', flowAdjustment: -1},
        { ...answers[3796], path: '1287', flowAdjustment: -1},
      ],
      B: [
        { ...answers[3792], path: '1289', },
        { ...answers[3794], path: '1289', },
        { ...answers[3797], path: '1289', },
      ],
      C: [
        { ...answers[3792], path: '1289', },
        { ...answers[3795], path: '1289', },
        { ...answers[3798], path: '1289', },
      ]
    }
  },
  1289: { // lift the TV?
    id: 1289,
    label: 'Can you help lift the TV?',
    answerType: RADIO,
    children: {
      A: [
        { ...answers[3799], path: '1287', },
        { ...answers[3800], path: '1287', },
      ]
    }
  },
  1287: { // What type of surface
    id: 1287,
    label: 'What type of surface will the TV be mounted to?',
    answerType: RADIO,
    hint: 'We do not mount on plaster, tile or stone facades.',
    children: {
      A: [
        { ...answers[3787], path: '1296', group: 'A' },
        { ...answers[3789], path: '1296', group: 'A' },
        { ...answers[3788], path: '1296', group: 'B'},
        { ...answers[3790], path: '1296', group: 'B' },
        { ...answers[3791], path: '1296', group: 'A' },
      ]
  }
  },
  1296: { // anthing else
    id: 1296,
    label: 'Anything else?',
    answerType: CHECKBOX,
    complete: true,
    children: {
      A: [
        { ...answers.internal,  path: null, complete: true},
        { ...answers.external,  path: null, complete: true },
        { ...answers[3826],     path: null, complete: true },
        { ...answers[3827],     path: null, complete: true },
        { ...answers[3825],     path: null, complete: true },
      ],
      B: [
        { ...answers.external,  path: null, complete: true },
        { ...answers[3826],     path: null, complete: true },
        { ...answers[3827],     path: null, complete: true },
        { ...answers[3825],     path: null, complete: true },
      ],
    }
  },
});
